exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".default_button:hover {\n  border-color: #0353E9 !important;\n  color: #0353E9 !important;\n}\n", ""]);

